'use es6';

import { fromJS } from 'immutable';
import { disableHighchartsAnimation } from 'reporting-data/lib/overrides';
export const defaultSeriesOptions = fromJS({
  connectNulls: true,
  turboThreshold: 2000,
  animation: false,
  dataLabels: {
    color: 'inherit',
    style: {
      fontWeight: 600
    }
  },
  pointPadding: 0.17,
  groupPadding: 0.17,
  states: {
    hover: {
      enabled: !disableHighchartsAnimation.enabled
    },
    inactive: {
      enabled: !disableHighchartsAnimation.enabled
    }
  }
});